import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      
      await fetch('https://readdy.ai/api/form/d600q09dkj8fk0538htg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });
      
      setIsSuccess(true);
      setEmail('');
      setTimeout(() => setIsSuccess(false), 3000);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-rose-50 to-blush-50 py-12 border-t border-rose-100">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Brand */}
            <div>
              <div className="text-2xl font-light text-gray-900 mb-4">
                Peau<span className="font-semibold text-rose-500">Glow</span>
              </div>
              <p className="text-sm text-gray-600">
                Révélez votre beauté naturelle avec nos soins et produits premium.
              </p>
            </div>

            {/* Boutique */}
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Boutique</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  <Link to="/boutique" className="hover:text-rose-500 transition-colors cursor-pointer">
                    Tous les produits
                  </Link>
                </li>
              </ul>
            </div>

            {/* Soins */}
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Soins</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  <Link to="/plasma-mons" className="hover:text-rose-500 transition-colors cursor-pointer">
                    Soins Plasma Froid
                  </Link>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Newsletter</h4>
              <p className="text-sm text-gray-600 mb-3">
                Reçois nos conseils beauté et offres exclusives
              </p>
              <form 
                id="footer-newsletter-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Ton email"
                  required
                  className="px-3 py-2 text-sm border border-rose-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-300 bg-white"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-rose-500 text-white text-sm font-medium rounded-lg hover:bg-rose-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
                >
                  {isSubmitting ? 'Envoi...' : 'Je m\'inscris'}
                </button>
                {isSuccess && (
                  <p className="text-xs text-green-600">✓ Merci ! Vérifie ta boîte mail.</p>
                )}
              </form>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-wrap gap-6 mb-8 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-rose-500"></i>
              <span>+32 472 52 11 10</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-rose-500"></i>
              <span>info@peauperlee.com</span>
            </div>
          </div>

          {/* Bottom */}
          <div className="pt-8 border-t border-rose-200 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <div className="flex items-center gap-4">
              <p>© 2024 PlasmaGlow. Tous droits réservés.</p>
              <Link 
                to="/mentions-legales" 
                className="hover:text-rose-500 transition-colors cursor-pointer"
              >
                Mentions légales
              </Link>
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-rose-500 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
